import axios from "axios";
import { handleUnauthorized, normalizeApiError } from "../utils/apiErrors";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalized = normalizeApiError(error);
    handleUnauthorized(normalized);
    return Promise.reject(normalized);
  }
);

export default api;
